import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useTheme } from "../theme";
import { useSettings } from "../hooks";

const LINKS = [
  { to: "/projeler", label: "Projeler" },
  { to: "/teslim-karnesi", label: "Teslim Karnesi" },
  { to: "/kurumsal", label: "Kurumsal" },
  { to: "/haberler", label: "Haberler" },
  { to: "/iletisim", label: "İletişim" },
];

export function SiteHeader({ transparan = false }) {
  const { gece, toggle } = useTheme();
  const settings = useSettings();
  const [inmis, setInmis] = useState(false);
  const [menu, setMenu] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    if (!transparan) return;
    const onScroll = () => setInmis(window.scrollY > window.innerHeight * 0.82);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [transparan]);

  useEffect(() => { setMenu(false); }, [loc.pathname]);

  const solid = !transparan || inmis;

  return (
    <>
      <header className={`ust ${solid ? "katı" : ""}`} data-testid="site-header">
        <Link to="/" className="marka" data-testid="logo-link">{settings?.logo_text || "ÖZALP"}</Link>
        <nav>
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? "aktif" : "")} data-testid={`nav-${l.to.slice(1)}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="sag">
          <button className="gecetusu" onClick={toggle} data-testid="tema-tusu" aria-label="Gündüz gece modu">
            <b /><span>{gece ? "Gece" : "Gündüz"}</span>
          </button>
          <button className="menu-tus" onClick={() => setMenu((m) => !m)} data-testid="mobil-menu-tusu" aria-label="Menü">
            {menu ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </header>
      <div className={`mobil-menu ${menu ? "acik" : ""}`}>
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} data-testid={`mobil-nav-${l.to.slice(1)}`}>{l.label}</NavLink>
        ))}
      </div>
    </>
  );
}
